import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import TourTypeForm from '../../../components/Forms/Websites/TourType/TourTypeForm';

const TourType = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('tourType'));

    const columns = [
        {
            name: 'Tour Type Name',
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Tour Type Image',
            width: '100px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    // src={`url(${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image})`}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
                    alt='side Img'
                />
            ),
        },
        {
            name: 'Description',
            wrap: true,
            center: 'true',
            selector: (row) => row?.description,
        },
        {
            name: 'Success Count',
            wrap: true,
            center: 'true',
            selector: (row) => row?.success_count,
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewServiceHandler = (formValue) => {
        const formData = formDataConverter(formValue);

        request.create('tourType', formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // update

    const updateServiceHandler = (formValue) => {
        const formData = formDataConverter(formValue);

        request.updateOne('tourType', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteServiceHandler = () =>
        request.delete('tourType', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Tour Type List'
            buttonTitle='Add new Tour Type'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Tour Type'
                    size='lg'
                >
                    <TourTypeForm apiHandler={createNewServiceHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Destination'
                    size='lg'
                >
                    <TourTypeForm apiHandler={updateServiceHandler} editData={selectedItem} />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteServiceHandler}
                />
            )}
        </CardLayout>
    );
};

export default TourType;
